import React from 'react'

import { PageGuardKepalaSkbTimKinerja } from 'app/KinerjaKepalaSKBPage/components/PageGuardKepalaSkbTimKinerja'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PenilaianPenetapanHub } from 'app/KinerjaKepalaSKBPage/pages/tim-kinerja/pelaksanaan/PenilaianPenetapanHub'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

type PageParams = {
  npsn: string
}

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<PageParams>> => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

function Page() {
  return (
    <PageGuardKepalaSkbTimKinerja>
      <PenilaianPenetapanHub />
    </PageGuardKepalaSkbTimKinerja>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
}

export default Page
